/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_CommandInputs */

const en_fulfillment_command = /** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulfillment Command`)
};

const es_fulfillment_command = /** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando de Cumplimiento`)
};

const fr_fulfillment_command = /** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande d'exécution`)
};

const de_fulfillment_command = /** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfüllungskommando`)
};

const id_fulfillment_command = /** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komando Pemenuhan`)
};

/** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */
const ja_fulfillment_command = en_fulfillment_command;

/** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */
const zh_fulfillment_command = en_fulfillment_command;

/** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */
const ar_fulfillment_command = en_fulfillment_command;

/** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */
const it_fulfillment_command = en_fulfillment_command;

/** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */
const ru_fulfillment_command = en_fulfillment_command;

/** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */
const pt_fulfillment_command = en_fulfillment_command;

/** @type {(inputs: Fulfillment_CommandInputs) => LocalizedString} */
const ko_fulfillment_command = en_fulfillment_command;

/**
* | output |
* | --- |
* | "Fulfillment Command" |
*
* @param {Fulfillment_CommandInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_command = /** @type {((inputs?: Fulfillment_CommandInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_CommandInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_command(inputs)
	if (locale === "es") return es_fulfillment_command(inputs)
	if (locale === "fr") return fr_fulfillment_command(inputs)
	if (locale === "de") return de_fulfillment_command(inputs)
	if (locale === "ja") return ja_fulfillment_command(inputs)
	if (locale === "zh") return zh_fulfillment_command(inputs)
	if (locale === "ar") return ar_fulfillment_command(inputs)
	if (locale === "id") return id_fulfillment_command(inputs)
	if (locale === "it") return it_fulfillment_command(inputs)
	if (locale === "ru") return ru_fulfillment_command(inputs)
	if (locale === "pt") return pt_fulfillment_command(inputs)
	return ko_fulfillment_command(inputs)
});